var React = require('react');

function EditAddress (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon_feather-edit-3","data-name":"Icon feather-edit-3","transform":"translate(-4 -3.673)"},[React.createElement("path",{"id":"Path_253","data-name":"Path 253","d":"M18,30h8","transform":"translate(-5.5 -10.463)","fill":"none","stroke":"#686868","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":0}),React.createElement("path",{"id":"Path_254","data-name":"Path 254","d":"M16.5,4.87a1.886,1.886,0,0,1,2.667,2.667L8.056,18.648,4.5,19.537l.889-3.556Z","transform":"translate(0 0)","fill":"none","stroke":"#686868","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1","key":1})]));
}

EditAddress.defaultProps = {"width":"17","height":"16.364","viewBox":"0 0 17 16.364"};

module.exports = EditAddress;

EditAddress.default = EditAddress;
